import moment from 'moment';
import { getTagMetadata, sendErrorWithOutResponse, sendErrorWithResponse } from './analytics';
import { decryptCredentials } from './cifrate';
import { MESSAGE_CANCEL_REQUEST } from './constants/api-constants';

/* eslint-disable */

export const getPlanByAge = (plans, age) => plans.find((plan) => plan.edadMinima <= parseInt(age, 10) && plan.edadMaxima >= parseInt(age, 10));

export const validateEmail = (email) => {
  // eslint-disable-next-line
  const regex =
    /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

export const verifyLetters = (val) => {
  const regex = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ\s]*$/i;
  const withoutSpaces = val.trim();
  return withoutSpaces.length > 0 && regex.test(withoutSpaces);
};

export const validatePhone = (value) => {
  const regex = /^[0-9]*$/;
  return !(!regex.test(value) || value.length !== 9 || value.charAt(0) !== '9');
};

export const validateDNI = (value) => {
  if (!value) {
    return false;
  }
  const regex = /^[0-9]*$/;
  return !(!regex.test(value) || value.length !== 8);
};

export const validateCE = (value) => value?.length >= 8;

export const findByField = (data, predicate) => data.find((item) => Object.keys(predicate).every((key) => item[key] === predicate[key]));

export const calculateAge = (date) => {
  const today = new Date();
  const birthday = new Date(date);
  let age = today.getFullYear() - birthday.getFullYear();
  const m = today.getMonth() - birthday.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthday.getDate())) {
    age -= 1;
  }
  return age;
};

export const getParameterValue = (sParametroNombre) => {
  var sPaginaURL = window.location.search.substring(1);
  var sURLVariables = sPaginaURL.split('&');
  for (var i = 0; i < sURLVariables.length; i++) {
    var sParametro = sURLVariables[i].split('=');
    if (sParametro[0] === sParametroNombre) {
      return sParametro[1];
    }
  }
  return null;
};

const convertParametersToArray = (parameter) => {
  const param = getParameterValue(parameter);
  return param.indexOf(':') !== -1 ? param.split(':') : param.split('%3A');
};
// eslint-disable-next-line
export const getCampaign = () => {
  var source = '',
    origenCampania = '',
    origenContenido = '',
    origenMedio = '',
    origenTipoPlan = '';
  if (getParameterValue('gclid') != null) {
    source = 'Google Adwords';
    if (getParameterValue('origen_fuente') != null) {
      source = getParameterValue('origen_fuente');
    }
    if (getParameterValue('origen_medio') != null) {
      origenMedio = getParameterValue('origen_medio');
    }
    if (getParameterValue('origen_campaign') != null) {
      origenCampania = getParameterValue('origen_campaign');
    }
  } else if (getParameterValue('utm_source') != null) {
    source = getParameterValue('utm_source');
    origenCampania = getParameterValue('utm_campaign');
    origenContenido = getParameterValue('utm_content');
  } else if (getParameterValue('origen_fuente') != null) {
    source = getParameterValue('origen_fuente');
  }

  if (getParameterValue('utm_medium') != null) {
    origenMedio = getParameterValue('utm_medium');
  } else if (getParameterValue('origen_medio') != null) {
    origenMedio = getParameterValue('origen_medio');
  }

  if (null != getParameterValue('tipoplan')) {
    origenTipoPlan = getParameterValue('tipoplan');
  }
  //Regla mcid
  if (getParameterValue('mcid') != null) {
    let arrParameters = convertParametersToArray('mcid');
    source = arrParameters[0];
    origenMedio = arrParameters[1];
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(':');
  }
  //Regla pcid
  if (getParameterValue('pcid') != null) {
    let arrParameters = convertParametersToArray('pcid');
    source = 'Internal Campaigns';
    origenMedio = arrParameters.slice(0, 2).join(':');
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(':');
  }
  //Regla rfid
  if (getParameterValue('rfid') != null) {
    let arrParameters = convertParametersToArray('rfid');
    source = 'Internal Reference';
    origenMedio = arrParameters.slice(0, 2).join(':');
    origenCampania = arrParameters[2];
    origenContenido = arrParameters.slice(3).join(':');
  }

  return {
    source,
    origenCampania,
    origenContenido,
    origenMedio,
    origenTipoPlan,
  };
};

export const formatPrice = (num) => num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

export const getFormatMount = (mount) => {
  const newMount = mount.split('.');
  return newMount[0];
};

export const getFormatDecimalMount = (mount) => {
  const newMount = mount.split('.');
  if (newMount[1]) {
    if (newMount[1].length === 1) {
      return `${newMount[1]}0`;
    }
    return newMount[1];
  }
  return '00';
};

export const getConvertStringToDate = (date, inputFormat) => {
  const fecha = moment(date, inputFormat);
  return fecha.toDate();
};

export const formatDate = (date) => moment(date).format('L');

export const capitalize = (text, type = 'CADA_PALABRA') => {
  let textTitleStyle;
  const textLower = text.toLowerCase();
  const arrayWords = textLower.split(' ');
  switch (type) {
    case 'TIPO_ORACION':
      textTitleStyle = textLower.charAt(0).toUpperCase() + textLower.slice(1);
      break;
    default:
      textTitleStyle = arrayWords.map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join();
      // eslint-disable-next-line
      textTitleStyle = textTitleStyle.replace(new RegExp(',', 'g'), ' ');
      break;
  }
  return textTitleStyle;
};

export const verifyHeight = (value) => {
  const height = /(^[0-2]{1})+[.]+([0-9]{2})?$/;
  if (value !== undefined) {
    return height.test(value);
  }
  return false;
};

export const verifyWeight = (value) => {
  const weight = /^[0-9]*$/;
  if (value !== undefined) {
    return weight.test(value);
  }
  return false;
};

export const verifyEmail = (value) => {
  // eslint-disable-next-line
  const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/;
  if (value !== undefined) {
    return regexEmail.test(value);
  }
  return false;
};

export const sortArrayObject = (arr, callback) => {
  const getValue = (obj) => {
    if (typeof callback === 'function') {
      return callback(obj);
    }
    return obj[callback];
  };

  return arr.sort((a, b) => {
    if (getValue(a) > getValue(b)) {
      return 1;
    }
    return -1;
  });
};

export const idePlans = {
  B1: 533105,
  B2: 0,
};

export const getDocumentTypeName = (documentType) => {
  switch (Number(documentType)) {
    case 2:
      return 'DNI';
    case 4:
      return 'CE';
    case 1:
      return 'RUC';
    default:
      return 'DNI';
  }
};

// function for return page error generic

export const getErrorPage = (error, step) => {
  // const navigate = useNavigate();
  const apisCanal = {
    OBTENER_PERSONA: {
      codigo: '001',
      url: '/personas/busqueda',
    },
    VALIDAR_POLIZA: {
      codigo: '002',
      url: '/polizas/validacion',
    },
    CREAR_COTIZACION: {
      codigo: '003',
      url: '/cotizaciones',
    },
    CALCULAR_DESCUENTO: {
      codigo: '004',
      url: '/descuentos/calculo',
    },
    EVALUAR_PREEXISTENCIAS: {
      codigo: '005',
      url: '/preexistencias/validacion',
    },
    VALIDAR_SINIESTROS: {
      codigo: '006',
      url: '/siniestros/validacion',
    },
    VALIDAR_IMC: {
      codigo: '007',
      url: '/imc/validacion',
    },
    ACTUAlIZAR_COTIZACION: {
      codigo: '008',
      url: '/cotizaciones',
    },
    AGREGAR_TERCERO: {
      codigo: '009',
      url: '/terceros',
    },
    SELECCIONAR_PLAN: {
      codigo: '010',
      url: '/planes/seleccion',
    },
    REGISTRAR_DPS: {
      codigo: '011',
      url: '/dps',
    },
    SUBIR_DPS: {
      codigo: '012',
      url: '/dps/subida',
    },
    PREGUNTAS_SUSCRIPCION: {
      codigo: '013',
      url: '/suscripciones',
    },
    RUTA_DPS: {
      codigo: '014',
      url: '/dps/rutas',
    },
    NOTIFICAR_BIENVENIDA: {
      codigo: '015',
      url: '/notificaciones/envio',
    },
    REGISTRO_PAGO: {
      codigo: '016',
      url: 'https://d3i3zjlr7wtztr.cloudfront.net/v2/checkout.min.js',
    },
    BUSCAR_DEPARTAMENTOS: {
      codigo: '017',
      url: '/utilitarios/departamento/buscar',
    },
    BUSCAR_PROVINCIAS: {
      codigo: '018',
      url: '/utilitarios/provincia/buscar',
    },
    BUSCAR_DISTRITOS: {
      codigo: '019',
      url: '/utilitarios/distrito/buscar',
    },
    GUARDAR_SESSION_PAGO: {
      codigo: '020',
      url: '/pagos/sesiones',
    },
    AGREGAR_LEADS: {
      codigo: '021',
      url: '/leads/registrar',
    },
    VALIDAR_TERCERO: {
      codigo: '022',
      url: '/tercero/validar',
    },
  };
  const errorResponse = error?.response;
  let url = '';
  if (error?.message === MESSAGE_CANCEL_REQUEST) {
    return MESSAGE_CANCEL_REQUEST;
  }
  if (errorResponse) {
    const errorData = errorResponse.data.error;
    if (errorData?.details) {
      url = sendErrorWithResponse(
        errorData,
        `${decryptCredentials(process.env.REACT_APP_CORE_API)}${apisCanal[step]?.url}`,
        apisCanal[step]?.codigo ?? '001-07',
      );
    } else {
      url = sendErrorWithOutResponse(apisCanal[step]?.codigo ?? '000', `${decryptCredentials(process.env.REACT_APP_CORE_API)}${apisCanal[step]?.url}`);
    }
  } else {
    url = sendErrorWithOutResponse(apisCanal[step]?.codigo ?? '000', `${decryptCredentials(process.env.REACT_APP_CORE_API)}${apisCanal[step]?.url}`);
  }
  return url;
};

export const generatePayloadValidar = (client) => {
  const { apellidoMaterno, apellidoPaterno, nombres, fechaNacimiento, sexo, numeroDocumento, tipoDocumento } = client;
  return {
    canal: 'saludflex',
    apepat: apellidoPaterno,
    apemat: apellidoMaterno,
    sexo,
    fecnac: fechaNacimiento,
    nombres,
    numeroDocumento,
    tipoDocumento: tipoDocumento.toString(),
  };
};

export const trackerBdu = (origin, typeDocument, numDocument, key, hundredPercent) => {
  const value = `${origin}_${typeDocument === 'dni' ? 'DNI' : 'CE'}-${numDocument}${hundredPercent ? ` _ ${hundredPercent}` : ''}`;
  getTagMetadata(`${key} - Seguro Salud Flexible`, value, 'trackMetadata');
};

export const trackingOrigenBDU = (origen, tipoDocumento, nroDocumento) => {
  console.log('origen track', origen);
  // eslint-disable-next-line no-param-reassign
  if (origen === undefined) origen = 'NE';
  const tipo = tipoDocumento === '2' ? 'DNI' : 'CE';
  getTagMetadata('Origen validacion Cliente - Seguro Salud Flexible', `${origen}_${tipo}-${nroDocumento}`, 'trackMetadata');
};

export const analizeRespValidar = (response, client) => {
  const { resultvalidacion } = response;
  if (resultvalidacion) {
    if (client.tipoDocumento === 2) {
      const { resultinputref } = resultvalidacion;
      trackerBdu(
        resultinputref.fuente,
        client.tipoDocumento === 2 ? 'dni' : 'ce',
        client.numeroDocumento,
        'Origen validación Cliente nuevo',
        `${resultinputref.porcentajeaprox} %`,
      );
      return resultinputref.porcentajeaprox === 100;
    }
    return true;
  }
  return false;
};

export const getCodeError = (error) => error.response?.data?.status?.error || '';

export const getCodeBduService = (msg) => {
  const regex = /[A-Z]+\d+/g;
  return msg.match(regex);
};

export const getTextFromAttempts = (value) => {
  const attempts = {
    1: 'Primer Intento - Datos incorrectos documento',
    2: 'Segundo Intento - Datos incorrectos documento',
    3: 'Intento fallido de validación tercero nuevo',
  };
  return attempts[value] || 'Primer Intento - Datos incorrectos documento';
};

export const removeAccents = (str) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const isValidImage = (image) => {
  return !!(image.image_mobile && image.image_mobile.url && image.image_desktop && image.image_desktop.url);
};

export const isValidUrl = (url) => {
  if (!url) return false;
  const trimmed = url.trim();
  return /^(https:\/\/[\w.-]+\.[a-z]{2,}(\/\S*)?|mailto:[\w.%+-]+@[\w.-]+\.[a-z]{2,}|tel:\+?\d{6,})$/i.test(trimmed);
};

export const getNextResetDate = (startDate, finalDate, resetDays) => {
  const start = new Date(startDate);
  const end = new Date(finalDate);
  const now = new Date();

  if (now < start || now > end) return null;

  if (resetDays === 0) return end;

  const msPerReset = resetDays * DAY_TO_MILISECONDS;
  const elapsed = now.getTime() - start.getTime();
  const resetsPassed = Math.floor(elapsed / msPerReset);
  const nextReset = new Date(start.getTime() + (resetsPassed + 1) * msPerReset);

  return nextReset > end ? end : nextReset;
};

export const shouldShowBanner = (time) => {
  if (!time?.start_date || !time?.final_date) return false;

  const start = new Date(time.start_date);
  const end = new Date(time.final_date);
  const now = new Date();

  if (isNaN(start.getTime()) || isNaN(end.getTime())) return false;

  if (start > end) return false;

  return now >= start && now <= end;
};
